import React, { useState } from "react";
import { LoadingButton } from "@mui/lab";
import axios from "axios";
import { toast } from "react-toastify";
import { API_ENDPOINT } from "../../../../../constants/constants";
import { getHeader } from "../../../../../utility/utility";
import { toastError } from "../../../../../utils2024/utils";
import { Box, Typography } from "@mui/material";
import CategorySelectorAccordions from "../../../common/CategorySelectorAccordions";

const CategoriesEdit = ({ user, show }) => {
  const [saving, setSaving] = useState(false);
  const [categories, setCategories] = useState(
    user.productCategories?.value || []
  );

  const save = async () => {
    const toUpdateObject = {
      productCategories: {
        label: user.productCategories.label,
        value: categories,
      },
    };
    setSaving(true);
    try {
      const { data } = await axios.post(
        `${API_ENDPOINT}user/update-user`,
        toUpdateObject,
        getHeader()
      );
      toast.success(data.message);
      setTimeout(() => {
        document.location.reload();
      }, 500);
    } catch (error) {
      toastError(error);
    } finally {
      setSaving(false);
    }
  };
  return (
    <Box m={2} mt={4}>
      <Typography mb={2} variant="h6">
        Update Product Categories
      </Typography>
      <CategorySelectorAccordions
        selectedCategories={categories}
        onSelectionChange={(newList) => {
          setCategories(newList);
        }}
        isOpen={show}
      />
      <Box mt={1} display={"flex"} justifyContent={"end"}>
        <LoadingButton variant="contained" onClick={save} loading={saving}>
          Save
        </LoadingButton>
      </Box>
    </Box>
  );
};

export default CategoriesEdit;
